import { Badge, Button, Popover, PopoverContent, PopoverTrigger, Stack } from "@altimateai/lego";
import { Column } from "../../types";

const ColumnTags = ({ columns }: { columns: Column[] }) => {
  // add dispay_name or name to set
  const tags = columns.reduce((acc, c) => {
    if (c.tags.length > 0) {
      c.tags.forEach(t => {
        acc.add(t.display_name || t.name || "");
      });
    }
    return acc;
  }, new Set<string>());

  if (!tags.size) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="!al-rounded-full !al-px-2 !al-py-1 al-text-xs al-h-auto al-bg-bg-brand al-group"
          onClick={e => e.stopPropagation()}
        >
          Column Tags:{" "}
          <div className="al-text-xs al-font-normal al-rounded-full al-bg-white al-text-black al-px-2 al-py-0 group-hover:al-bg-primary group-hover:al-text-white">
            {tags.size}
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="al-w-[200px]">
        <Stack gap="sm" direction="column" align="start" onClick={e => e.stopPropagation()}>
          {Array.from(tags).map(tag => (
            <Badge key={tag} variant="outline" className="al-bg-bg-brand">
              {tag}
            </Badge>
          ))}
        </Stack>
      </PopoverContent>
    </Popover>
  );
};

export default ColumnTags;
